import {Injectable} from "@angular/core";
import {Loglevel} from "./loglevel.model";
import {environment} from "../../environments/environment";

export const synchronizationModes: Array<SynchronizationMode> = ["instant", "on_exception"];
export type SynchronizationMode = "instant" | "on_exception";

@Injectable()
export class LogConfigService {

  public clientLevel: Loglevel = environment.clientLevel;
  public serverLevel: Loglevel = environment.serverLevel;

  public clientToServerSynchronizationMode: SynchronizationMode = "instant";

  public onExceptionLogBulkSize = 10;

}
